import { useEffect } from "react";
import { motion } from "framer-motion";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const Section = ({ title, children }) => (
  <div className="border-b border-black/10 py-8">
    <h2 className="font-semibold text-xl text-[#111418] mb-3">{title}</h2>
    <div className="text-black/60 text-sm leading-relaxed flex flex-col gap-3">{children}</div>
  </div>
);

export const Devoluciones = () => {
  useEffect(() => {
    document.title = "Cambios, devoluciones y garantía - Ruta 360";
  }, []);

  return (
    <div data-testid="devoluciones-page" className="bg-white min-h-screen">
      <Header />
      <main className="pt-[100px]">
        <div className="max-w-4xl mx-auto px-6 py-14 lg:py-20">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <h1 className="font-display text-5xl sm:text-6xl uppercase font-semibold leading-none tracking-tight text-[#111418] mb-10">
              Cambios, devoluciones y garantía
            </h1>

            <Section title="Cambios">
              <p>
                Tienes 7 días naturales desde que recibes tu pedido para cambiarlo por otro producto o talla, aunque
                solo sea porque cambiaste de opinión. El producto debe estar sin uso, con empaque y accesorios
                completos.
              </p>
            </Section>

            <Section title="Devoluciones de dinero">
              <p>
                No hacemos devoluciones de dinero por arrepentimiento. En ese caso con gusto te ofrecemos un cambio.
              </p>
              <p>
                Devolución de dinero solo si el producto llega dañado, con defecto de fábrica o no es el que pediste.
                Avísanos por WhatsApp en los primeros 7 días con fotos o video, y el reembolso se hace de 7 a 14 días.
              </p>
            </Section>

            <Section title="Cómo solicitarlo">
              <p>
                Escríbenos por WhatsApp al +52 1 228 408 1782 o a pescadeportivamx@gmail.com con tu número de pedido
                y el motivo.
              </p>
            </Section>

            <Section title="Envío de regreso">
              <p>
                Si el producto llegó dañado, incompleto o no es el que pediste, nosotros cubrimos el envío. Si es por
                cambio de opinión, el envío de regreso corre por tu cuenta.
              </p>
            </Section>

            <Section title="Reembolso">
              <p>
                Una vez que recibimos y revisamos el producto, te devolvemos tu dinero en un plazo de 7 a 14 días
                hábiles, por el mismo medio de pago.
              </p>
            </Section>

            <Section title="Garantía de 1 año">
              <p>
                Todos nuestros productos tienen 1 año de garantía contra defectos de fabricación, ya incluida en el
                precio. No cubre mal uso, golpes, caídas, daños por agua en productos que no son resistentes al agua
                ni el desgaste normal.
              </p>
            </Section>

            <Section title="Cómo usar la garantía">
              <p>
                Mándanos por WhatsApp una foto o video del problema y tu número de pedido. Te decimos si se repara,
                se cambia o se reembolsa.
              </p>
            </Section>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
